import { keyframes } from '@emotion/react';

const getAnimation = keyframes`
0% { transform: translateY(0); },
100% { transform: translateY(-24px); }
`;

export const style = {
  Typography: {
    sx: {
      flex: 1,
      color: 'action.active',
    },
  },
  flex: {
    sx: {
      display: 'flex',
      gap: 1,
      alignItems: 'center',
    },
  },
  box: {
    sx: {
      position: 'fixed',
      left: '50%',
      marginLeft: '-320px',
      bottom: 0,
      backgroundColor: '#130F35',
      borderRadius: '8px',
      animation: `${getAnimation} 500ms cubic-bezier(0.250, 0.460, 0.450, 0.940)  both`,
    },
  },
  row: {
    sx: {
      width: 640,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: 64,
      lineHeight: 64,
      color: 'action.active',
      mx: 1,
    },
  },
} as const;
